export default __webpack_public_path__ + "static/media/App_Role_Configuration.8bd1b88c.png";